import { render } from "./consent_form.html?vue&type=template&id=75306402&scoped=true&external"
import script from "./consent_form.js?vue&type=script&lang=js&external"
export * from "./consent_form.js?vue&type=script&lang=js&external"

import "./ConsentForm.vue?vue&type=style&index=0&id=75306402&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75306402"]])

export default __exports__